import React , {Component} from 'react';
import {Link} from 'react-router-dom';
import axios from 'axios';
import {Button, Input, Select, TextArea} from "../layout/Form";

export default class EditEntrepreneurship extends Component{
    state={
        category:'',
        city:'',
        price:'',
        description:'',
        rentalCost:'',
        workStaff:'',
        inCome:'',
    }
    componentDidMount(){
        axios.get(`https://arianaapp.arianaapply.com/api/V1/get_single_entrepreneurship/${this.props.match.params.id}`)
        .then(res=>{
            console.log(res)
            this.setState({
                category:res.data.category,
                city:res.data.city,
                price:res.data.price,
                description:res.data.description,
                rentalCost:res.data.rentalCost,
                workStaff:res.data.workStaff,
                inCome:res.data.inCome,
            })
        }).catch(err=>{
            console.log(err)
        })
    }

    inputHandle(event) {
        const input = event.target.name;
        const value = event.target.value;
        this.setState({[input]: value})

    }
    
    image(e) {
        this.setState({file: e.target.files[0]});
    }
    render(){
        const{
            category,
            city,
            price,
            description,
            rentalCost,
            workStaff,
            inCome,
        } = this.state;
        return(

            <div className="index">
            <form method="POST" >
                <Input title="دسته بندی" change={this.inputHandle.bind(this)} name="category" value={category}/>
                <Input title="شهر" change={this.inputHandle.bind(this)} name="city" value={city}/>
                <Input title="هزینه" change={this.inputHandle.bind(this)} name="price" value={price}/>
                <Input title="توضیحات" change={this.inputHandle.bind(this)} name="description" value={description}/>
                <Input title="rentalCost" change={this.inputHandle.bind(this)} name="rentalCost" value={rentalCost}/>
                <Input title="workStaff" change={this.inputHandle.bind(this)} name="workStaff" value={workStaff}/>
                <Input title="inCome" change={this.inputHandle.bind(this)} name="inCome" value={inCome}/>

                <div className="inputBox">
                    <label>عکس</label>
                    <input type="file" name="file" onChange={this.image.bind(this)}/>

                </div>
                <Button className="btn-success" type="submit" title="ثبت"/>

            </form>
        </div>
        
        )
    }
}